import {
    AfterViewInit,
    ApplicationRef,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    QueryList,
    TemplateRef,
    ViewChild,
    ViewChildren,
    ViewEncapsulation,
} from "@angular/core";

import { fuseAnimations } from "@fuse/animations";
import { Subscription } from "rxjs";
import { StorageService } from "../../../common/service/storage.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConfigService } from "../../../common/config/config.service";
import { Globals } from "../../../common/global";
import { MatDialog } from "@angular/material/dialog";
//  import { OthermachineService } from './othermachine.service';
import { Maintenance } from "../maintenance";
import * as moment from "moment-timezone";
import { Load } from "../../load/load";
import { MaintenanceService } from "../maintenance.service";
import { TranslateService } from "@ngx-translate/core";
// import { MaintenaceService } from '../maintenace.service';

const timeZone = require("moment-timezone");

@Component({
    selector: "app-othermachine",
    templateUrl: "./othermachine.component.html",
    styleUrls: ["./othermachine.component.scss"],
    animations: fuseAnimations,
})
export class OthermachineComponent implements OnInit, OnDestroy, AfterViewInit {
    patient: string;
    data = [];
    columns = [];
    titleMatIcon = this.getTitleMatIcon();
    title = this.getTitle();
    displayedColumns = [];
    dataSource = new MatTableDataSource<any>(this.data);
    @ViewChild("filter", { static: true })
    filter: ElementRef;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;
    // isLoading = true;
    // alertSign = "";
    // enableInfoMsg = false;
    // protected extraCta = {
    //     visibility: false,
    //     text: "",
    // };

    page: number;
    hasFirstDataShown = false;
    private dataSubscription: Subscription;
    errorMessage: any;
    isInitComplete: boolean;
    maintenanceOtherData: Maintenance[] = [];
    isLoading: boolean;
    prev: number;
    next: number;
    count: number;
    isNextPressed: boolean;
    paginationDisabled: boolean;
    hasMoreData: boolean = true;
    PAGE_SIZE: number = 10;
    private observer: MutationObserver | null = null;
    overflowFlags: boolean[] = [];
    @ViewChildren("cellContent") cellContents!: QueryList<ElementRef>;

    constructor(
        private userSevice1Child: StorageService,
        public dialog: MatDialog,
        private route: ActivatedRoute,
        public snackBar: MatSnackBar,
        // public historyService:MaintenaceService,
        public global: Globals,
        public configService: ConfigService,
        private paginationService: MaintenanceService,
        private userService: StorageService,
        private router: Router,
        private translate: TranslateService,
        private el: ElementRef,
        private cdr: ChangeDetectorRef,
    ) {
        //  super(snackBar, configService, global);
    }

    /**
     * On init
     */
    ngOnInit(): void {
        this.isInitComplete = true;
        this.dataSource.data = [];
        this.maintenanceOtherData = [];
        // this.getCassetteConfig();
        this.isLoading = true;
        this.prev = 0;
        this.next = 1;
        this.page = 0;
        this.count = 1;
        const lab_id = this.userService.getCookie("lab_id");
        const keys = [
            "Common.Sr",
            "Maintenance.Name",
            "Common.Type",
            "Cassettes.Result",
            "Maintenance.CreatedOn",
            "Maintenance.CreatedBy",
            "Maintenance.MaintainedOn",
            "Maintenance.MaintainedBy",
        ];
        this.translate.onLangChange.subscribe(() => {
            this.translate.get(keys).subscribe((translations) => {
                this.columns = this.getColumn(translations);
                this.displayedColumns = this.columns.map((c) => c.columnDef);
            });
        });

        this.translate.get(keys).subscribe((translations) => {
            this.columns = this.getColumn(translations);
            this.displayedColumns = this.columns.map((c) => c.columnDef);
        });

        if (lab_id) {
            this.getAllData(1);
        } else {
            this.logout();
        }
    }

    logout(): void {
        localStorage.clear();
        this.userService.clearCookie();
        // this.globals.cassetteConfig = null;
        this.router.navigate(["/login"]);
        // location.reload();
    }

    getAllData(page) {
        this.isInitComplete = true;
        this.paginationService.getAllDataOtheremaintenace(page).subscribe(
            (a) => {
                //   // // console.log(,);
                Object.entries(a).find(([key, value]) => {
                    if (key == "message" && value == "No data Found") {
                        this.paginationDisabled = true;
                        this.openSnackBar(
                            this.translateSentence("Common.noDataFound"),
                            this.translateSentence("Common.ok"),
                        );
                    }
                    if (key == "data") {
                        this.isInitComplete = false;
                        this.data = value;
                        this.hasMoreData = this.data.length === this.PAGE_SIZE;
                        if (!this.hasMoreData && this.isNextPressed) {
                            this.openSnackBar(
                                this.translateSentence(
                                    "Common.noFurtherDataAvailable",
                                ),
                                this.translateSentence("Common.ok"),
                            );
                        }
                        this.data.forEach((element) => {
                            // // // console.log(e);
                            this.maintenanceOtherData.push({
                                cellName: element.cell_name
                                    ? element.cell_name
                                    : element.cell_id,
                                type: element.type,
                                machineName: element.machine_name,
                                cycleNo: element.cycle_number,
                                barcode: element.load_id,
                                createdBy: element.created_by,
                                createdOn: element,
                                startedBy: element.created_by,
                                updatedOn: element.updated_by.timestamp,
                                updatedBy: element.updated_by,
                                aiResult: this.getStatus(element.jarvis_result),
                                status: element.jarvis_result,
                                aiLink: element.image_url,
                                id: "",
                                docId: "",
                            });
                        });
                    } else {
                        // // // console.log(e);
                    }
                });

                this.dataSource.data = this.maintenanceOtherData;
                //  // // console.log(a);
            },

            (err) => {
                this.errorMessage = err.error.message;
                // // console.log(e);
                if (err.status == 401) {
                    alert(this.translateSentence("Login.invalidToken"));
                    // this.logout()
                }
            },
        );
    }

    onNextPress() {
        this.isLoading = true;
        this.isNextPressed = true;
        this.count = this.count + 1;
        this.next = this.prev + 1;
        this.prev = this.next - 1;
        this.next++;
        this.prev++;
        this.getAllData(this.next);
        // // console.log(v);
    }

    getRowBackgroundColor(element): string {
        // if (element.deleted == true) {
        //     return "lightgrey";
        // } else
        return "#FFFFFF";
    }

    getRowFontColor(element) {
        if (element.deleted == true) {
            return "italic";
        } else return "bold";
    }

    getFontColor(element) {
        if (element.deleted == true) {
            return "#808080";
        } else return "#000000";
    }
    getCrossWord(element) {
        if (element.deleted == true) {
            return "line-through";
        } else return "overline";
    }

    getColumn(translations: { [key: string]: string }): any[] {
        return [
            {
                columnDef: "Sr",
                header: translations["Common.Sr"],
                hide: false,
                cell: (element: Load, index: number) =>
                    `${this.page * 10 + index + 1}`,
            },
            {
                columnDef: "Name",
                header: translations["Maintenance.Name"],
                hide: false,
                cell: (element: Maintenance, index: number) =>
                    `${element.cellName}`,
                //   this.replaceWithEmptyCellName(element)
            },
            {
                columnDef: "Type",
                header: translations["Common.Type"],
                hide: false,
                cell: (element: Maintenance, index: number) =>
                    `${this.replaceWithEmpty(element.type)}`,
                // this.replaceWithEmpty(element.type)
            },

            //   {
            //       columnDef: "CycleNo",
            //       header: "CycleNo",
            //       hide: false,
            //       cell: (element: Maintenance, index: number) =>
            //     //   `${element.cycleNo}`,
            //     this.replaceWithEmpty(element.cycleNo)
            //   },

            {
                columnDef: "MaintenanceNo",
                header: translations["Maintenance.CreatedOn"],
                hide: false,
                cell: (element: Maintenance, index: number) =>
                    `${this.replaceWithEmptycreted(element)}`,
                // this.replaceWithEmptycreted(element)
            },

            {
                columnDef: "CreatedBy",
                header: translations["Maintenance.CreatedBy"],
                hide: false,
                cell: (element: Maintenance, index: number) =>
                    `${this.replaceWithCreatedBy(element.createdBy)}`,
                //   this.replaceWithCreatedBy(element.createdBy)
            },

            {
                columnDef: "MaintainedOn",
                header: translations["Maintenance.MaintainedOn"],
                hide: false,
                cell: (element: Maintenance, index: number) =>
                    `${this.getDateStringMomentByTz(element.updatedOn)}`,
            },

            {
                columnDef: "MaintainedBy",
                header: translations["Maintenance.MaintainedBy"],
                hide: false,
                cell: (element: Maintenance, index: number) =>
                    `${this.replaceWithEmpty(element.updatedBy.name)}`,
                //   this.replaceWithEmpty(element.updatedBy)
            },
            {
                columnDef: "Result",
                header: translations["Cassettes.Result"],
                hide: false,
                cell: (element: Maintenance, index: number) => {
                    const result = this.replaceWithEmpty(element.aiResult);
                    const translationKey = `Result.${result}`;
                    return this.translateSentence(translationKey);
                },
                //    this.replaceWithEmpty(element.aiResult)
            },

            {
                columnDef: "action",
                header: "",
                hide: false,
                cell: (element: Maintenance, index: number) => null,
            },
        ];
    }
    replaceWithCreatedBy(createdBy) {
        if (createdBy != undefined) {
            // // // console.log(y);
            if (createdBy.name != undefined) {
                return createdBy.name;
            } else {
                return " ";
            }
        } else {
            return "-";
        }
    }

    replaceWithEmptyCellName(value) {
        // // // console.log(e);

        if (value.cellName != undefined && value.cellName != null) {
            // // // console.log(y);
            return value.cellName;
        } else {
            return value.cellId;
        }
    }

    replaceWithEmptycreted(value) {
        // // // console.log(e);
        if (value.createdBy != undefined && value.createdBy != null) {
            // // // console.log(');
            if (value.createdBy.timestamp != undefined) {
                return this.getDateStringMomentByTz(value.createdBy.timestamp);
            }
        } else {
            // // // console.log(');
            return this.getDateStringMomentByTz(value.updated_timestamp);
        }
    }

    replaceWithEmpty(value) {
        const exitingValue = value;

        if (value == undefined) {
            return "-";
        } else {
            return exitingValue;
        }
    }

    getDateStringMomentByTz(time): string {
        // // // console.log(e);

        if (time != undefined && time != "-") {
            var timestamp = parseInt(time);
            if (timestamp) {
                if (timestamp < 0) timestamp = timestamp * -1;
                const localTimeZone = moment(timestamp).tz(
                    this.userSevice1Child.getCookie("defaultTz"),
                );
                return localTimeZone.format("DD-MM-YYYY | HH:mm");
            }
        } else {
            return time;
        }
    }

    getStringOrDefault(reqkey: any, defaulvalue: any) {
        const rg = defaulvalue;
        try {
            if (reqkey === undefined || reqkey === null) {
                return defaulvalue;
            } else {
                return reqkey;
            }
        } catch (error) {
            rg == defaulvalue;
        }
    }

    updateRow(row): any {
        // setDeriveFields(row);
    }

    // ngOnDestroy() {
    //     this.subscription.unsubscribe();
    //     OthermachineComponent.oldData = this.dataSource.data;
    //     // OthermachineComponent.cursor = this.infiniteScroll.getCursor();
    // }

    getTitleMatIcon(): string {
        return "art_track";
    }

    getTitle(): string {
        return "Other Maintenance History";
    }

    getSearchText(): string {
        return "Search Patient via name";
    }

    addZeroToHourAndMinutes(date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        const strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
        // if (time < 10) {
        //     return '0' + time;
        // }
        // return time;
    }

    getMapValue(stringData) {
        const param = stringData.replace(/[^a-zA-Z0-9]/g, "");
        const obj = {};
        for (let j = 0; j <= param.length - 1; j++) {
            let emptyString = "";
            for (let k = 0; k <= j; k++) {
                emptyString += param[k];
            }

            obj[emptyString] = true;
        }
        return obj;
    }

    toUpperCaseString(str) {
        return str.trim().toUpperCase();
    }

    private handleError(error: Error): void {
        // this.openSnackBar(error.message, "OK");
        // this.notify.update(error.message, 'error');
    }

    changeTimestampToDate(timestamp) {
        if (timestamp) {
            // new Date('03/17/2021');
            // return timeZone(timestamp).tz(this.userSevice1Child.getCookie('defaultTz')).format('DD/MM/YYYY');
            return moment(timestamp).format("DD/MM/YYYY | HH:mm");
        }
        return "";
    }

    @HostListener("document:keypress", ["$event"])
    handleKeyboardEvent(event: KeyboardEvent) {
        // this.handleEnterSearch(event);
    }

    // getSubscriptionType() {
    //     // // console.log(e);
    //     switch (this.navigationType) {
    //         case "screening":
    //             return true;
    //         default:
    //             return false;
    //     }
    // }

    openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }

    openDetail(ref: TemplateRef<any>) {
        this.dialog.open(ref, {
            disableClose: true,
            width: "450px",
        });
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    ngAfterViewInit(): void {
        const table: HTMLElement | null =
            this.el.nativeElement.querySelector("mat-table");
        if (!table) return;

        this.observer = new MutationObserver((mutations) => {
            if (!this.isNextPressed) return;

            const rows = table.querySelectorAll(".mat-row");
            if (rows.length > 0) {
                const last = rows[rows.length - 1] as HTMLElement;
                last.scrollIntoView({ behavior: "smooth", block: "end" });
                this.isNextPressed = false;
            }
        });

        this.observer.observe(table, { childList: true, subtree: true });
        this.updateOverflowFlags();

        this.cellContents.changes.subscribe(() => this.updateOverflowFlags());
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private updateOverflowFlags(): void {
        this.overflowFlags = this.cellContents.map((el) =>
            this.isTextOverflowing(el.nativeElement),
        );
        this.cdr.detectChanges();
    }

    isTextOverflowing(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth;
    }

    getStatus(status: string) {
        switch (status) {
            case "InProcess":
                return "Pending";
            case "Success":
                return "Success";
            case "Failed":
                return "Failed";
            default:
                return status;
        }
    }
}
